import { css } from '@emotion/core';

export const button = css`
  display: flex;
`;
